import * as types from "./types";
import { DELETED } from "../../constants/invoiceStatuses";

const invoiceState = {
  invoice: null,
  isWebhookInvocationAllowed: false,
  isVoidAllowed: false,
  error: null,
  statusError: null,
  statusSuccess: null
};

export default (state = invoiceState, action) => {
  switch (action.type) {
    case types.CLEAR_STORE: {
      return {
        ...state,
        ...invoiceState
      };
    }
    case types.DELETE_INVOICE_AGENT: {
      return {
        ...state,
        invoice: { ...state.invoice, agent: null }
      };
    }
    case types.FETCHING_INVOICE_SUCCESS: {
      return {
        ...state,
        invoice: action.payload
      };
    }
    case types.DEACTIVATE_STATEMENT_SUCCESS: {
      if (state.invoice.code === action.payload.groupInvoiceNumber) {
        const invoice = { ...state.invoice };
        invoice.status = DELETED;

        return { ...state, invoice };
      }

      return { ...state };
    }
    case types.CHANGE_INVOICE_STATUS_SUCCESS: {
      return {
        ...state,
        statusSuccess: action.payload
      };
    }
    case types.CHECK_WEBHOOK_STATUS_SUCCESS: {
      return { ...state, isWebhookInvocationAllowed: action.payload };
    }
    case types.CHECK_VOID_AVAILABLE_SUCCESS: {
      return { ...state, isVoidAllowed: action.payload };
    }
    case types.DEACTIVATE_STATEMENT_ERROR:
    case types.FETCHING_INVOICE_ERROR:
    case types.CHECK_WEBHOOK_STATUS:
    case types.REFRESH_WEBHOOK: {
      return {
        ...state,
        error: action.payload
      };
    }
    case types.CHANGE_INVOICE_STATUS_ERROR: {
      return {
        ...state,
        statusError: action.payload
      };
    }
    default:
      return state;
  }
};
